// 初始化页面表单埋点对象：为每个字段创建一份独立的输入/修改统计状态。
export function createFormTracking (fieldMap) {
  const fields = {}
  Object.keys(fieldMap).forEach(key => {
    fields[key] = createFieldTracking()
  })

  return {
    pageEnterTime: Date.now(),
    fields
  }
}

// 重置页面表单埋点对象：页面重新进入时调用，清空所有字段统计并重新计算页面停留时长。
export function resetFormTracking (tracking, fieldMap) {
  tracking.pageEnterTime = Date.now()
  Object.keys(fieldMap).forEach(key => {
    tracking.fields[key] = createFieldTracking()
  })
}

// 记录字段开始编辑：输入框 focus 或选择框打开时调用，保存开始时间和编辑前的值。
export function startFormFieldTracking (tracking, key, value) {
  const field = tracking.fields[key]
  if (!field) return
  field.focusTime = Date.now()
  field.focusValue = normalizeTrackingValue(value)
}

// 记录字段结束编辑：输入框 blur 或选择框关闭时调用，只在值发生变化时统计本次时长，单位：秒。
export function finishFormFieldTracking (tracking, key, value) {
  const field = tracking.fields[key]
  if (!field || !field.focusTime) return

  const duration = getDurationSeconds(field.focusTime)
  const nextValue = normalizeTrackingValue(value)
  if (nextValue !== field.focusValue) {
    if (!field.hasFirstInput) {
      field.duration = duration
      field.hasFirstInput = true
    } else {
      field.revisenum += 1
      field.reviseduration = normalizeDurationSeconds(field.reviseduration + duration)
    }
  }
  field.focusTime = 0
  field.focusValue = ''
}

// 生成提交接口需要的埋点字段：xxx_duration、xxx_revisenum、xxx_reviseduration 和 pagestay_duration，时长单位：秒。
export function getFormTrackingData (tracking, fieldMap) {
  const data = {}
  Object.keys(fieldMap).forEach(key => {
    const field = tracking.fields[key] || createFieldTracking()
    const prefix = fieldMap[key]
    data[`${prefix}_duration`] = field.duration
    data[`${prefix}_revisenum`] = field.revisenum
    data[`${prefix}_reviseduration`] = field.reviseduration
  })
  data.pagestay_duration = getDurationSeconds(tracking.pageEnterTime)
  return data
}

// 把开始时间到结束时间的毫秒差转换成秒，并四舍五入成整数。
export function getDurationSeconds (startTime, endTime = Date.now()) {
  return normalizeDurationSeconds(Math.max(endTime - startTime, 0) / 1000)
}

// 创建单个字段的默认埋点状态。
function createFieldTracking () {
  return {
    // 本次获焦时间。
    focusTime: 0,
    // 本次获焦时的字段值，用于判断失焦时是否真的修改过。
    focusValue: '',
    // 首次输入/选择的耗时，单位：秒。
    duration: 0,
    // 首次输入/选择之后，发生修改的总次数。
    revisenum: 0,
    // 首次输入/选择之后，所有修改行为累计耗时，单位：秒。
    reviseduration: 0,
    // 是否已经记录过首次输入/选择。
    hasFirstInput: false
  }
}

// 统一把字段值转成字符串，避免 null、undefined 和数字类型影响前后值比较。
function normalizeTrackingValue (value) {
  if (value === null || value === undefined) return ''
  return String(value)
}

function normalizeDurationSeconds (seconds) {
  return Math.round(seconds)
}
